function getOmnibusPriceFromAPI(brand, ID, omnibusContainer, variantPrice, hasPromo, currency) {

   return fetch(createOmnibusEndpoint(brand, ID, currency))
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return renderOmnibusPriceFromAPI(omnibusContainer, data.price, variantPrice, hasPromo);
    })
    .catch(function (e) {
      console.error("Error fetching Omnibus price:", e);
      return 0;
    });
}

function renderOmnibusPriceFromAPI(omnibusPriceContainer, price, variantPrice, has_promo) {

  if (has_promo == 0) {
    hideomnibusPriceContainer(omnibusPriceContainer);
    return;
  }

  if (!price) {
    hideomnibusPriceContainer(omnibusPriceContainer);
    return;
  }
  omnibusPriceContainer.classList.remove('hidden');
  var omnibuspriceValue = omnibusPriceContainer.querySelector('.omnibusprice-value');
  omnibuspriceValue.innerText = theme.Currency.formatMoney(price.toFixed(2), theme.moneyFormat);
}

function hideomnibusPriceContainer(omnibusPriceContainer) {
  if (!omnibusPriceContainer.classList.contains('hidden')) {
    omnibusPriceContainer.classList.add('hidden');
  }
}

function createOmnibusEndpoint(brand, ID, currency) {
    var currencyParam = currency ? "&currency=" + currency : "";
    return "https://omnibus.filoblu.com/?brand=" + brand + "&sku=" + ID + "&market=" + window.location.host + window.Shopify.routes.root + currencyParam;
}


var initTemplate = function () {
  var variantID = document.getElementById('omnibusprice').dataset.omnibus_id;
  var variantPrice = document.getElementById('omnibusprice').dataset.variant_price;
  renderOmnibusPrice(variantID, variantPrice);
};

var renderOmnibusPrice = function (variantID, variantPrice) {
  var omnibusContainer = document.getElementById('omnibusprice');
  var brand = document.getElementById('omnibusprice').getAttribute('data-omnibus_brand');
  var currency = document.getElementById('omnibusprice').getAttribute('data-currency');
  var hasPromo = document.getElementById('omnibusprice').getAttribute('data-promo');
  getOmnibusPriceFromAPI(brand, variantID, omnibusContainer, variantPrice, hasPromo, currency);
};

window.addEventListener('renderOmnibusPrice', function (evt) {

  renderOmnibusPrice(evt.detail.id, evt.detail.price);
}, false);

if (document.readyState != "loading") {
  initTemplate();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    initTemplate();
  });
}
